import axios from 'axios';
import config from '@assets/config.json'; // api 请求json  

// 分类获取banner
const state = { 
}
const mutations = { 
}
const getters = { 
}
const actions = {   
  getContactUsForGroup({rootState}) { // 联系我们
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/ContactUs/GetForGroup`).then((data) => {
        if (data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(false);
        }
      }).catch(err => console.log(err));
    });
  }, 
  getContactUsForGroupEn({rootState}) { // 英文版联系我们
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/ContactUs/GetListByGroup?group=5`).then((data) => {
        if (data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(false);
        }
      }).catch(err => console.log(err));
    });
  }, 
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}

